import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';


const SkeletonListaEmpleados = ({ rows = 10 }) => {
    return (
        <>
            {Array.from({ length: rows }).map((_, index) => (
                <Col key={index} xs={12}>
                    <Card className="shadow-none border mb-3">
                        <Card.Body className="p-3">
                            <Row className="align-items-center g-3">
                                {/* FOTO DE PERFIL SKELETON */}
                                <Col xs={12} sm={6} md={2} className="text-center">
                                    <Skeleton circle width={110} height={110} />
                                </Col>

                                {/* INFORMACIÓN PRINCIPAL SKELETON */}
                                <Col xs={12} sm={6} md={3}>
                                    <Skeleton width="80%" height={20} className="mb-2" />
                                    <Skeleton width="40%" height={16} className="mb-2" />
                                    <Skeleton width={80} height={24} borderRadius={12} />
                                </Col>

                                {/* CATEGORÍA SKELETON */}
                                <Col xs={12} sm={6} md={2}>
                                    <Skeleton width={60} height={12} className="mb-1" />
                                    <Skeleton width={90} height={24} borderRadius={12} />
                                </Col>

                                {/* DATOS DE CONTACTO SKELETON */}
                                <Col xs={12} sm={6} md={5}>
                                    <Skeleton width="90%" height={16} className="mb-2" />
                                    <Skeleton width="85%" height={16} className="mb-2" />
                                    <Skeleton width="70%" height={16} />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
        </>
    );
};
SkeletonListaEmpleados.propTypes = {
    rows: PropTypes.number
};
export default SkeletonListaEmpleados;